import { Divider, Grid, Group, Text } from '@mantine/core';

import { TimeBlock } from '../../components/train-route-info/train-route-info';
import { UiCard } from '../../components/ui/ui-card/ui-card';
import { getNameLocal } from '../../lib/local/get-title';
import { useLocal } from '../../lib/local/use-local';

type TripInfoProps = {
  trip?: {
    trainType: { name: string };
    route: { name: string };
    finishTime: string;
    startTime: string;
  };
  startStation?: { nameRu: string };
  endStation?: { nameRu: string };
};

export const TripInfo = ({ trip, startStation, endStation }: TripInfoProps) => {
  const [lang] = useLocal();
  return (
    <UiCard>
      {trip && (
        <Group align="center" spacing="xs">
          <Text span bg="#f4f4f4" p="4px 6px" styles={{ borderRadius: 4 }}>
            {trip.trainType.name}
          </Text>

          <Text span color="#4a4a4a" fz="14px">
            {trip.route.name}
          </Text>
        </Group>
      )}

      <Grid align="center" justify="center" gutter={10} mt={12}>
        <Grid.Col span="content">
          <TimeBlock
            date={new Date(trip?.startTime || 0)}
            target={getNameLocal(lang, startStation)}
          />
        </Grid.Col>
        <Grid.Col span="auto">
          <Divider my={4} />
        </Grid.Col>
        <Grid.Col span="content">
          <TimeBlock
            date={new Date(trip?.finishTime || 0)}
            target={getNameLocal(lang, endStation)}
            direction="end"
          />
        </Grid.Col>
      </Grid>
    </UiCard>
  );
};
